// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap___2SiK","actionsCol":"EnrolledClinics_actionsCol__1bSOC"};